/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
      }),
    });
  }

  delete(conversationID, messageId, scope) {
    const url = `${this.url}/${conversationID}/messages/${messageId}`;
    return scope ? axios.delete(url, { params: { scope } }) : axios.delete(url);
  }

  edit(conversationId, messageId, content) {
    return axios.patch(`${this.url}/${conversationId}/messages/${messageId}`, {
      content,
    });
  }

  react(conversationId, messageId, emoji) {
    return axios.put(
      `${this.url}/${conversationId}/messages/${messageId}/reaction`,
      { emoji }
    );
  }

  getReactionParticipants(conversationId, messageId) {
    return axios.get(
      `${this.url}/${conversationId}/messages/${messageId}/reactions`
    );
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getForwardTargets(conversationId, messageId, params) {
    return axios.get(
      `${this.url}/${conversationId}/messages/${messageId}/forward_targets`,
      { params }
    );
  }

  forward(conversationId, messageId, targetConversationId, requestId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/forward`,
      { target_conversation_id: targetConversationId, request_id: requestId }
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  sendBrowserWhatsappList(conversationId, templateId, variables) {
    return axios.post(
      `${this.url}/${conversationId}/messages/send_browser_whatsapp_list`,
      {
        template_id: templateId,
        variables,
      }
    );
  }
}

export default new MessageApi();
